import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { WorkOrderSearchTextForm } from '../../../form-model/work-order-search-text.form.model';
import { utils } from '../../../helper/utils';
@Component({
  selector: 'app-approval-all-search',
  imports: [FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './approval-all-search.component.html',
  styleUrl: './approval-all-search.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ApprovalAllSearchComponent {
  @Input() selectedTabVal: string = '';
  @Input({ required: true }) workOrderSearchTextForm!: FormGroup<WorkOrderSearchTextForm>;
  applySearchTextFilters() {
    this.workOrderSearchTextForm.controls.appliedWOSearchTextFilter.setValue(true);
    this.workOrderSearchTextForm.controls.tabSelected?.setValue(this.selectedTabVal);
  }
  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    utils.setupWorkOrderSearchControls(this.formBuilder, this.workOrderSearchTextForm, { includeTabSelected: true });
  }

  isControlInErrorState(control: FormControl): boolean | null {
    return utils.isControlInErrorState(control);
  }
}
